import { StyleSheet } from 'react-native';
export const style = StyleSheet.create({
    textRed: {
        color: 'rgba(255, 73, 6, 1)',
    },
    cardBox: {
        backgroundColor: '#fff',
    },
    iconRight: {
        width: 16,
        height: 16,
    },
    navbar: {
        position: 'relative',
        width: '100%',
        height: 48,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderBottomWidth: 1,
        borderBottomColor: '#EAEAEA',
        paddingHorizontal: 19,
    },
});
